import mainApiClient from '../interceptor.mainApiClient';

const highRiskZoneEndpoints = {
  getZoneVisitStats: (alienId, config) =>
    mainApiClient.get(`/api/v1/aliens/${alienId}/zone-visits/stats`, config),

  getZoneVisitHistory: (alienId, config) =>
    mainApiClient.get(`/api/v1/aliens/${alienId}/zone-visits`, config),

  getZoneExposureScore: (alienId, config) =>
    mainApiClient.get(`/api/v1/aliens/${alienId}/zone-visits/exposure-score`, config),

  getActiveZones: (config) =>
    mainApiClient.get(`/api/v1/high-risk-zones`, config),

  getZoneById: (zoneId, config) =>
    mainApiClient.get(`/api/v1/high-risk-zones/${zoneId}`, config),

  checkPointInZones: (data, config) =>
    mainApiClient.post(`/api/v1/high-risk-zones/check`, data, config),
};

export default highRiskZoneEndpoints;
